import React, {Component} from "react";
import {getPoints} from "../services/UserStatsService";
import './PointsProgress.css';

export class PointsProgress extends Component {
    render() {
        const targetPoints = 100;
        const {subjectKey} = this.props;
        const points = getPoints(subjectKey);
        const percentage = Math.round(100 * points / targetPoints);
        const colorNone = "#e6e6e6";
        const colorFirst = "#f77a52";
        const colorSecond = "#f70000";
        let colorA = colorNone;
        let colorB = colorFirst;
        if (percentage > 100) {
            colorA = colorFirst;
            colorB = colorSecond;
        }
        return <div>
            <p>{points} points / {targetPoints}</p>
            <svg className="pointsProgress" width="120" height="120" viewBox="0 0 120 120">
                <circle cx="60" cy="60" r="45" fill="none" stroke={colorA} strokeWidth="30"/>
                <circle cx="60" cy="60" r="45" fill="none" stroke={colorB} strokeWidth="30"
                        pathLength="100" strokeDashoffset={100 - percentage % 100} strokeDasharray="100"
                        strokeLinecap="round"/>
                <text textAnchor="middle" transform="translate(56,60) rotate(90)">{percentage} %</text>
            </svg>
        </div>
    }
}

